import { rest } from 'msw'
import mockedLegalAgreements from '../../../__mocks__/Agreements/legalAgreements.json'
import mockedPendingAgreements from '../../../__mocks__/Agreements/pendingAgreements.json'

export const getPendingAgreements = rest.get(
  `${API_URL}/api/accounts-management/v1/accounts/agreements`,
  async (req, res, ctx) => {
    return res(ctx.json(mockedPendingAgreements))
  }
)

export const updatePendingAgreements = rest.put(
  `${API_URL}/api/business/account/applicable-agreement`,
  async (req, res, ctx) => {
    return res(ctx.status(200))
  }
)

export const updatePendingAgreementsException = rest.put(
  `${API_URL}/api/business/account/applicable-agreement`,
  async (req, res, ctx) => {
    return res(ctx.status(404))
  }
)

export const updatePendingAgreementsPermissionsException = rest.put(
  `${API_URL}/api/business/account/applicable-agreement`,
  async (req, res, ctx) => {
    return res(ctx.status(403))
  }
)

export const getLegalAgreements = rest.get(
  `${API_URL}/api/accounts-management/v1/accounts/agreements`,
  async (req, res, ctx) => {
    return res(ctx.json(mockedLegalAgreements))
  }
)

export const getLegalAgreementsEmpty = rest.get(
  `${API_URL}/api/accounts-management/v1/accounts/agreements`,
  async (req, res, ctx) => {
    return res(ctx.status(200))
  }
)

export const getLegalAgreementsException = rest.get(
  `${API_URL}/api/accounts-management/v1/accounts/agreements`,
  async (req, res, ctx) => {
    return res(ctx.status(404))
  }
)

export default [getPendingAgreements, updatePendingAgreements, getLegalAgreements]
